import React, { Component } from 'react';
import { Popover, Button, Icon } from 'antd';
import FormList from '../../../basicElement/FormList.new.js';
import compareFn from '../Components/compareFn';
import format from '../../../shared/format';
import { getMatchOption } from '../../../shared/selectFn';

class FormOther extends Component {
    getColumns = () => {
        const { mode, data, names, prevData, options } = this.props;
        const { hgracServiceNeedOrNot, patientImageInfoOrNot, intensivePKBloodOrNot } = data;
        const { dataCollectionMediumOptions, defaultOptions } = options;
        const showHgracApplicationTimes = getMatchOption(defaultOptions, 'value', hgracServiceNeedOrNot).value == 1;
        const showPatientImageInfoNum = getMatchOption(defaultOptions, 'value', patientImageInfoOrNot).value == 1;
        const showInvolvingIntensivePKBloodNum = getMatchOption(defaultOptions, 'value', intensivePKBloodOrNot).value == 1;

        // 字段属性配置
        const columns = [{
            key: 'siteNum',
            type: 'inputNumber',
            attr: {
                name: names.siteNum,
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'filterPatient',
            type: 'inputNumber',
            attr: {
                name: names.filterPatient,
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'randomPatient',
            type: 'inputNumber',
            attr: {
                name: names.randomPatient,
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'perPtsVisitNum',
            type: 'inputNumber',
            attr: {
                name: names.perPtsVisitNum,
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'perPtsOnSiteVisitNum',
            type: 'inputNumber',
            attr: {
                name: names.perPtsOnSiteVisitNum,
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'perPtsTeleVisitNum',
            type: 'inputNumber',
            attr: {
                name: names.perPtsTeleVisitNum,
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'dataCollectionMedium',
            type: 'radio',
            attr: {
                name: names.dataCollectionMedium,
                options: dataCollectionMediumOptions,
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'saeNum',
            type: 'inputNumber',
            attr: {
                name: names.saeNum,
            },
            attrRules: {
                prefix: <span>随机病例 * </span>,
                unit: '%'
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'hgracServiceNeedOrNot',
            type: 'radio',
            attr: {
                name: names.hgracServiceNeedOrNot,
                options: defaultOptions,
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'hgracApplicationTimes',
            type: 'input',
            attr: {
                name: names.hgracApplicationTimes,
            },
            attrRules: {
                required: true,
            },
            display: showHgracApplicationTimes
        }, {
            key: 'centerPathologicalNeedOrNot',
            type: 'radio',
            attr: {
                name: names.centerPathologicalNeedOrNot,
                options: defaultOptions,
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'radioraphReadingOrNot',
            type: 'radio',
            attr: {
                name: names.radioraphReadingOrNot,
                options: defaultOptions,
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'patientImageInfoOrNot',
            type: 'radio',
            attr: {
                name: names.patientImageInfoOrNot,
                options: defaultOptions,
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'patientImageInfoNum',
            type: 'inputNumber',
            attr: {
                name: names.patientImageInfoNum,
            },
            attrRules: {
                required: true,
            },
            display: showPatientImageInfoNum
        }, {
            key: 'centralLaboratoryOrNot',
            type: 'radio',
            attr: {
                name: names.centralLaboratoryOrNot,
                options: defaultOptions,
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'intensivePKBloodOrNot',
            type: 'radio',
            attr: {
                name: names.intensivePKBloodOrNot,
                options: defaultOptions,
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'involvingIntensivePKBloodNum',
            type: 'inputNumber',
            attr: {
                name: names.involvingIntensivePKBloodNum,
            },
            attrRules: {
                required: true,
            },
            display: showInvolvingIntensivePKBloodNum
        }, {
            key: 'eTMFOrNot',
            type: 'radio',
            attr: {
                name: names.eTMFOrNot,
                options: defaultOptions,
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'servicePeriod',
            type: 'text',
            attr: {
                name: names.servicePeriod,
            },
            attrRules: {
                unit: '月'
            },
        }, {
            key: 'preparationPeriod',
            type: 'inputNumber',
            attr: {
                name: names.preparationPeriod,
            },
            attrRules: {
                unit: '月',
                required: true,
            },
        }, {
            key: 'ssuServiceIncludedOrNot',
            type: 'radio',
            attr: {
                name: names.ssuServiceIncludedOrNot,
                options: defaultOptions,
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'enrolmentPeriod',
            type: 'inputNumber',
            attr: {
                name: names.enrolmentPeriod,
            },
            attrRules: {
                unit: '月',
                required: true,
            },
        }, {
            key: 'treatmentPeriod',
            type: 'inputNumber',
            attr: {
                name: names.treatmentPeriod,
            },
            attrRules: {
                unit: '月',
                required: true,
            },
        }, {
            key: 'followupPeriod',
            type: 'inputNumber',
            attr: {
                name: names.followupPeriod,
            },
            attrRules: {
                unit: '月',
                required: true,
            },
        }, {
            key: 'survivalFollowupPeriod',
            type: 'inputNumber',
            attr: {
                name: names.survivalFollowupPeriod,
            },
            attrRules: {
                unit: '月',
                required: true,
            },
        }, {
            key: 'dbl',
            type: 'inputNumber',
            attr: {
                name: names.dbl,
            },
            attrRules: {
                unit: '月',
                required: true,
            },
        }, {
            key: 'siteCloseout',
            type: 'inputNumber',
            attr: {
                name: names.siteCloseout,
            },
            attrRules: {
                unit: '月',
                required: true,
            },
        }, {
            key: 'crcMonthlyRate',
            type: 'inputNumber',
            attr: {
                name: names.crcMonthlyRate,
                precision: 2,
            },
            attrRules: {
                unit: '元/FTE',
                required: true,
            },
        }, {
            key: 'pmMonthlyRate',
            type: 'inputNumber',
            attr: {
                name: names.pmMonthlyRate,
                precision: 2,
            },
            attrRules: {
                unit: '元/FTE',
                required: true,
            },
        }, {
            key: 'fpiDate',
            type: 'datePicker',
            attr: {
                name: names.fpiDate,
            },
            attrRules: {
                required: true,
            },
        }];

        // 字段值、显示状态配置
        const traverseColumns = function (columns) {
            columns.forEach(column => {
                const { key, type, attr } = column;
                if (mode === 'compare') {
                    attr.value = compareFn(prevData, data, key);
                } else {
                    if (type === 'datePicker') {
                        attr.value = format('date', data[key]);
                    } else {
                        attr.value = data[key];
                    }
                    if (mode === 'note') {
                        const attrRules = column.attrRules || (column.attrRules = {});
                        attrRules.suffix = (
                            <Popover
                                title={
                                    <div>
                                        <div style={{ display: 'flex' }}>
                                            <strong>陶志红[200166] 2021-03-02 12:52</strong>
                                            <div style={{ marginLeft: 16 }}>
                                                <Icon type="check-square-o" />
                                                <Icon type="edit" />
                                                <Icon type="close-circle-o" />
                                            </div>
                                        </div>
                                        <p style={{ lineHeight: '24px' }}>
                                            计划书填写日期2021年3月2日
                                        </p>
                                    </div>
                                }
                                overlayClassName="quotation-popover"
                                content={<Button type="primary">添加备注</Button>}
                            >
                                <Icon type="message" className="icon-note" style={{ marginLeft: 16 }} />
                            </Popover>
                        );
                    }
                }
                column.comment = {
                    name: names.comments
                };
            });
        }
        traverseColumns(columns);

        return columns;
    }

    render() {
        const { formRef, language, editable, onChange } = this.props;
        return (
            <FormList
                fieldWidth={320}
                language={language}
                editable={editable}
                columns={this.getColumns()}
                onChange={onChange}
                className="hasComment"
                ref={el => formRef(el)}
            />
        );
    }
}

export default FormOther;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Params/FormOther.js